import JSONModel from "sap/ui/model/json/JSONModel";
import toUrl = sap.ui.require.toUrl;

type DevelopmentConfig = {
  apiToken?: string;
}

export default class Config {
  public static readonly Version: string = "3.4.0_22/12/2025_T9:50";
  public static readonly LoginUrl: string = "/Boarding/index.html";
  public static readonly BackendUrl: string = "/IpsCore";
  public static readonly TransferApi: string = "/public/service/erp";
  public static readonly FileUploadApi: string = "/private/service/file";
  public static readonly UploadApi: string = "/cockpit/private/odata.srv/";
  public static readonly RestApi: string = "/cockpit/private/service";
  public static readonly PublicRestUrl: string = "/IpsCore/cockpit/public/service";
  public static readonly ODataApi: string = "/cockpit/private/odata.srv/";

  private static developmentConfig: DevelopmentConfig = null;

  public getValue(p_sKey: string) {
    switch (p_sKey) {
      case "LoginUrl":
        return Config.LoginUrl;
      case "BackendUrl":
        return Config.BackendUrl;
      case "TransferApi":
        return Config.TransferApi;
      case "FileUploadApi":
        return Config.FileUploadApi;
      case "UploadApi":
        return Config.UploadApi;
      case "RestApi":
        return Config.RestApi;
      case "PublicRestUrl":
        return Config.PublicRestUrl;
      case "ODataApi":
        return Config.ODataApi;
      default:
        return "";
    }
  }

  public getRestUrl(): string {
    return Config.BackendUrl + Config.RestApi;
  }

  public getFileUrl(): string {
    return Config.BackendUrl + Config.FileUploadApi;
  }

  public getDevelopmentConfig(): DevelopmentConfig {
    const model = new JSONModel();
    model.loadData(toUrl("ips/ac/config/developmentConfig.json"), null, false);

    if (Config.developmentConfig == null) {
      Config.developmentConfig = model.getData();
    }

    return Config.developmentConfig;
  }
}